<template>
    <div>
        <a-spin :spinning="loading">
            <!--    搜索条件    -->
            <div class="mb20">
                <a-form layout="inline" class="mb10" :wrapper-col="{ span:24 }">
                    <a-row :gutter="[10, 10]">
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-input  :placeholder="$t('web.name' /* 姓名 */)" v-model="searchParams.name" />
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-input placeholder="英文名" v-model="searchParams.given_name" style="width: 100%" />
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-input placeholder="英文姓" v-model="searchParams.family_name" style="width: 100%" />
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-input :placeholder="$t('web.company' /* 单位 */)" v-model="searchParams.org_name" style="width: 100%" />
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-input placeholder="手机/邮箱" v-model="searchParams.email_mobile" style="width: 100%" />
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="角色任务" v-model="searchParams.juese" style="width: 100%;" allowClear>
                                    <a-select-option v-for="item in fayanTypeList" :key="item.id" :value="item.id">
                                        {{item.typename_cn}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="照片" v-model="searchParams.avatar" style="width: 100%" allowClear>
                                    <a-select-option :value="1">已提交</a-select-option>
                                    <a-select-option :value="0">未提交</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="简历" v-model="searchParams.resume_en" style="width: 100%" allowClear>
                                    <a-select-option :value="1">已提交</a-select-option>
                                    <a-select-option :value="0">未提交</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="简历PPT" v-model="searchParams.resume_ppt" style="width: 100%" allowClear>
                                    <a-select-option :value="1">已上传</a-select-option>
                                    <a-select-option :value="0">未上传</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="摘要" v-model="searchParams.vc" style="width: 100%" allowClear>
                                    <a-select-option :value="1">已提交</a-select-option>
                                    <a-select-option :value="0">未提交</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="授权状态" v-model="searchParams.authorization_state" style="width: 100%" allowClear>
                                    <a-select-option :value="1">同意</a-select-option>
                                    <a-select-option :value="0">未确认</a-select-option>
                                    <a-select-option :value="2">拒绝</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="直播授权状态" v-model="searchParams.authorization_state_live" style="width: 100%" allowClear>
                                    <a-select-option :value="1">同意</a-select-option>
                                    <a-select-option :value="0">未确认</a-select-option>
                                    <a-select-option :value="2">拒绝</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="是否上传视频" v-model="searchParams.is_upload" style="width: 100%" allowClear>
                                    <a-select-option :value="1">已上传</a-select-option>
                                    <a-select-option :value="2">未上传</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="日期" v-model="searchParams.date_id" style="width: 100%" allowClear>
                                    <a-select-option v-for="item in dateList" :key="item.id" :value="item.id">{{item.meeting_date}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="会场" v-model="searchParams.hall_id" style="width: 100%" allowClear>
                                    <a-select-option v-for="item in hallList" :key="item.id" :value="item.id">{{item.meeting_hall}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="分论坛" v-model="searchParams.xuezu_id" style="width: 100%" allowClear>
                                    <a-select-option v-for="item in xuezuList" :key="item.id" :value="item.id">{{item.class_cnname}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="中外宾" v-model="searchParams.cnen" style="width: 100%" allowClear>
                                    <a-select-option value="">中外宾</a-select-option>
                                    <a-select-option value="cn">中宾</a-select-option>
                                    <a-select-option value="en">外宾</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="是否接受" v-model="searchParams.acceptance_state" style="width: 100%" allowClear>
                                    <a-select-option :value="0">未回复</a-select-option>
                                    <a-select-option :value="1">接受</a-select-option>
                                    <a-select-option :value="2">拒绝</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="课件视频是否验收完成" v-model="searchParams.video_status" style="width: 100%" allowClear>
                                    <a-select-option :value="0">未完成</a-select-option>
                                    <a-select-option :value="1">已完成</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-date-picker placeholder="上传视频日期" v-model="searchParams.video_date" style="width: 100%"/>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select :placeholder="$t('program.meeting_type')/* 参会形式 */" style="width: 100%" v-model="searchParams.teaching_form">
                                    <a-select-option :value="1">{{ $t('program.meeting_type1') /* 录播 */ }}</a-select-option>
                                    <a-select-option :value="2">{{ $t('program.meeting_type2') /* 线上连接 */ }}</a-select-option>
                                    <a-select-option :value="3">{{ $t('program.meeting_type3') /* 现场参会 */ }}</a-select-option>
                                    <a-select-option :value="0">{{ $t('program.meeting_type4') /* 未确定 */ }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="直播方式" v-model="searchParams.live_mode" style="width: 100%" allowClear>
                                    <a-select-option :value="0">线下</a-select-option>
                                    <a-select-option :value="1">线上</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="是否测试完成" v-model="searchParams.test_progress" style="width: 100%" allowClear>
                                    <a-select-option :value="0">否</a-select-option>
                                    <a-select-option :value="1">是</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="声音画质是否正常" v-model="searchParams.hardware" style="width: 100%" allowClear>
                                    <a-select-option :value="0">否</a-select-option>
                                    <a-select-option :value="1">是</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <!-- <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="负责人" v-model="searchParams.switch" style="width: 100%" allowClear>
                                    <a-select-option v-for="item in listObj.fzr_list" :key="item.id" :value="item.id">{{item.real_name}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col> -->
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="任务负责人" v-model="searchParams.duty_follow_user_id" style="width: 100%" allowClear>
                                    <a-select-option v-for="item in listObj.fzr_list" :key="item.id" :value="item.id">{{item.real_name}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="是否已分配负责人" v-model="searchParams.is_allocate" style="width: 100%" allowClear>
                                    <a-select-option :value="1">是</a-select-option>
                                    <a-select-option :value="0">否</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="视频点播同步状态" v-model="searchParams.video_sync" style="width: 100%" allowClear>
                                    <a-select-option :value="1">视频点播未同步</a-select-option>
                                    <a-select-option :value="2">视频点播同步中</a-select-option>
                                    <a-select-option :value="3">视频点播同步失败</a-select-option>
                                    <a-select-option :value="4">视频点播已上传</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-select placeholder="是否上传幻灯PPT" v-model="searchParams.is_upload_ppt" style="width: 100%" allowClear>
                                    <a-select-option :value="-1">未上传</a-select-option>
                                    <a-select-option :value="1">已上传</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xxl="3" :xl="4" :lg="6" :md="8" :sm="12">
                            <a-form-item style="width: 100%">
                                <a-button type="primary" class="mr5" @click="handleSearchEvent">{{ $t('web.query' /* 查询 */) }}</a-button>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <!--  表格  -->
            <a-table
                ref="table"
                :rowKey="record => record.id"
                :columns="columns"
                :data-source="dataSource"
                :pagination="pagination"
                :scroll="{ x: 1520 }"
                @change="handleTableChange"
                @showSizeChange="handleTableChange"
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: handleSelectChange }">
                <template slot="starttime_slot" slot-scope="text, record">
                    <div>{{ text }}-{{ record.endtime_slot }}</div>
                </template>
                <template slot="action" slot-scope="text, record">
                    <a-button type="link" @click="$refs.dutyEditModalRef.showFun(record.user_id, record)">{{ $t('web.edit' /* 编辑 */) }}</a-button>
                    <div>
                        <span>参会形式：</span>
                        <span v-if="record.teaching_form == 1">{{ $t('program.meeting_type1') /* 录播 */ }}</span>
                        <span v-if="record.teaching_form == 2">{{ $t('program.meeting_type2') /* 线上连接 */ }}</span>
                        <span v-if="record.teaching_form == 3">{{ $t('program.meeting_type3') /* 现场参会 */ }}</span>
                        <span v-if="record.teaching_form == 0">{{ $t('program.meeting_type4') /* 未确定 */ }}</span>
                    </div>
                    <div>
                        <span v-if="record.teaching_form == 1">已测试</span>
                        <span v-else>未测试</span>
                    </div>
                </template>
                <!-- 是否接受 -->
                <template slot="acceptance_state" slot-scope="text, record">
                    <template v-if="text == 1 || text == 2">
                        <!-- 接受 -->
                        <div v-if="text == 1">
                            <div><a-tag color="green">已接受</a-tag></div>
                            <div>备注：{{record.remarks}}</div>
                        </div>
                        <!-- 拒绝 -->
                        <div v-if="text == 2">
                            <a-tag color="red">已拒绝</a-tag>
                        </div>
                        <div>提交时间：{{record.submit_time}}</div>
                    </template>
                    <div v-else>
                        未回复
                    </div>
                </template>

                <template slot="avatar" slot-scope="text, record">
                    <a-tag v-if="text" color="green">有</a-tag>
                    <a-tag v-else color="red">无</a-tag>
                </template>

                <template slot="resume" slot-scope="text, record">
                    <div v-if="text">
                        <a-tag color="green">有</a-tag>
                        <div>更新时间：{{record.resume_update_time}}</div>
                    </div>
                     <div v-else>
                        <a-tag color="red">无</a-tag>
                    </div>
                </template>

                <template slot="resume_en" slot-scope="text, record">
                    <div v-if="text">
                        <a-tag color="green">有</a-tag>
                        <div>更新时间：{{record.resume_en_update_time}}</div>
                    </div>
                     <div v-else>
                        <a-tag color="red">无</a-tag>
                    </div>
                </template>

                <template slot="resume_ppt" slot-scope="text">
                    <a-button class="mb5" type="link" size="small">上传</a-button>
                    <div v-if="text == 1">
                        <a-tag color="green">已上传</a-tag>
                    </div>
                     <div v-else class="mb5">
                        <a-tag color="red">未上传</a-tag>
                    </div>
                    <a-button type="link" size="small">word</a-button>
                    <a-button type="link" size="small">ppt</a-button>
                </template>

                <template slot="is_upload_ppt" slot-scope="text">
                    <a-button class="mb5" type="link" size="small">上传</a-button>
                    <div v-if="text == 1">
                        <a-tag color="green">已上传</a-tag>
                    </div>
                     <div v-else class="mb5">
                        <a-tag color="red">未上传</a-tag>
                    </div>
                </template>

                <template slot="is_learning_objective" slot-scope="text">
                    <a-button class="mb5" type="link" size="small">编辑</a-button>
                    <div v-if="text == 1">
                        <a-tag color="green">有</a-tag>
                    </div>
                     <div v-else class="mb5">
                        <a-tag color="red">无</a-tag>
                    </div>
                </template>

                <template slot="is_disclosure_form" slot-scope="text">
                    <a-button class="mb5" type="link" size="small">上传</a-button>
                    <div v-if="text == 1">
                        <a-tag color="green">已上传</a-tag>
                    </div>
                     <div v-else class="mb5">
                        <a-tag color="red">未上传</a-tag>
                    </div>
                </template>

                <template slot="vc_url" slot-scope="text">
                    <div v-if="text">
                        <a-tag color="green">有</a-tag>
                    </div>
                     <div v-else class="mb5">
                        <a-tag color="red">无</a-tag>
                    </div>
                </template>
                
                <template slot="meeting_date" slot-scope="text, record">
                    <div>{{text}}</div>
                    <div>{{record.starttime_slot}}</div>
                </template>
                
                <template slot="authorization_state" slot-scope="text">
                    <a-tag v-if="text == 1" color="green">同意</a-tag>
                    <a-tag v-else-if="2" color="red">拒绝</a-tag>
                    <a-tag v-else color="orange">未确认</a-tag>
                </template>

                <template slot="is_upload" slot-scope="text, record">
                    <a-button class="mb5" type="link" size="small">上传</a-button>
                    <template>
                        <div v-if="text == 1">
                            <a-tag color="green">已上传</a-tag>
                        </div>
                        <div v-else class="mb5">
                            <a-tag color="red">未上传</a-tag>
                        </div>
                    </template>
                    <template>
                        <div v-if="record.video_status == 1">
                            <a-tag color="green">已完成</a-tag>
                        </div>
                        <div v-else class="mb5">
                            <a-tag color="red">未完成</a-tag>
                        </div>
                    </template>
                </template>
            </a-table>
        </a-spin>
        <duty-edit-modal ref="dutyEditModalRef"/>
    </div>
    
</template>
<script>
import dutyEditModal from './components/duty-edit-modal.vue'
export default {
    name: 'ProgramhDutyConmfirm',
    components: {
        dutyEditModal
    },
    data() {
        return {
            searchParams: {
            },
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showTotal: total => {
                    this.$t('web.pagination_total', { value: total } /* 共 {total} 条 */);
                },
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '30', '50', '100']
            },
            dataSource: [],
            fayanTypeList: [],
            dateList: [],
            hallList: [],
            xuezuList: [],
            selectedRowKeys: [],
            listObj: {},
            columns: [
                {
                    title: '姓名',
                    dataIndex: 'real_name',
                    width: 100
                },
                {
                    title: '手机号',
                    dataIndex: 'mobile',
                    width: 100
                },
                {
                    title: '邮箱',
                    dataIndex: 'email',
                    width: 100
                },
                {
                    title: '国籍',
                    dataIndex: 'country_name',
                    width: 100
                },
                {
                    title: '是否接受',
                    dataIndex: 'acceptance_state',
                    scopedSlots: { customRender: 'acceptance_state' },
                    width: 100
                },
                {
                    title: '照片',
                    dataIndex: 'avatar',
                    scopedSlots: { customRender: 'avatar' },
                    width: 100
                },
                {
                    title: '简历',
                    dataIndex: 'resume',
                    scopedSlots: { customRender: 'resume' },
                    width: 100
                },
                {
                    title: '简历EN',
                    dataIndex: 'resume_en',
                    scopedSlots: { customRender: 'resume_en' },
                    width: 100
                },
                {
                    title: '简历PPT',
                    dataIndex: 'resume_ppt',
                    scopedSlots: { customRender: 'resume_ppt' },
                    width: 100
                },
                {
                    title: '幻灯PPT',
                    dataIndex: 'is_upload_ppt',
                    scopedSlots: { customRender: 'is_upload_ppt' },
                    width: 100
                },
                {
                    title: '课程目标',
                    dataIndex: 'is_learning_objective',
                    scopedSlots: { customRender: 'is_learning_objective' },
                    width: 100
                },
                {
                    title: '披露文件',
                    dataIndex: 'is_disclosure_form',
                    scopedSlots: { customRender: 'is_disclosure_form' },
                    width: 100
                },
                {
                    title: '摘要',
                    dataIndex: 'vc_url',
                    scopedSlots: { customRender: 'vc_url' },
                    width: 100
                },
                {
                    title: this.$t('web.date' /* 日期 */),
                    dataIndex: 'meeting_date',
                    scopedSlots: { customRender: 'meeting_date' },
                    width: 100
                },
                {
                    title: this.$t('program.batch_live_label_hall' /* 会场 */),
                    dataIndex: 'meeting_hall',
                    align: 'left',
                    width: 150
                },
                {
                    title: '角色/任务',
                    dataIndex: 'typename_cn',
                    align: 'left',
                    width: 100
                },
                {
                    title: '名称',
                    dataIndex: 'abstract_title',
                    align: 'left',
                    width: 100
                },
                {
                    title: '劳务费金额',
                    dataIndex: 'servicefee',
                    align: 'left',
                    customRender: (val) => val != 0 && val ? `${val} 人民币` : '无劳务费',
                    width: 100
                },
                {
                    title: '授权状态',
                    dataIndex: 'authorization_state',
                    scopedSlots: { customRender: 'authorization_state' },
                    align: 'left',
                    width: 100
                },
                {
                    title: '是否上传视频',
                    dataIndex: 'is_upload',
                    scopedSlots: { customRender: 'is_upload' },
                    width: 100,
                    align: 'left'
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    align: 'center',
                    width: 200,
                    fixed: 'right'
                }
            ],
            loading: false
        };
    },
    methods: {
        // 表格变化
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
        },
        handleSearchEvent () {
            this.getProgramConfirmList()
        },
        handleSelectChange (list) {
            this.selectedRowKeys = list
        },
        getProgramConfirmList () {
            this.$request.get({ url: 'getProgramConfirmList', data: { ...this.searchParams } }).then((res) => {
                const { count, data } = res.data
                this.dataSource = data
                this.pagination.total = Number(count)
            })
        },
          /**
         * ## 获取发言类型列表
         */
        getProgramFayanListFun() {
            this.$request.get({ url: 'getProgramFayanList', }).then(res => {
                this.fayanTypeList = res.data
            });
        },
        getProgramDateList () {
            this.$request.get({ url: 'getProgramDateList' }).then(res => {
                this.dateList = res.data;
            });
        },
        // 会场列表
        getProgramHallList () {
            this.$request.get({ url: 'getProgramHallList' }).then((res) => {
                this.hallList = res.data
            })
        },
        // 分论坛列表
        getProgramXuezuList () {
            this.$request.get({ url: 'getProgramXuezuList' }).then((res) => {
                this.xuezuList = res.data
            })
        },
        // getProgramFormList() {
        //     this.$request.get({ url: 'getProgramFormList'}).then(res => {
        //         this.listObj = res.data;
        //     });
        // },
    },
    created() {
        this.getProgramConfirmList()
        this.getProgramFayanListFun()
        this.getProgramDateList()
        this.getProgramHallList()
        this.getProgramXuezuList()
        // this.getProgramFormList()
    },
    mounted() {
    }
};
</script>